import * as FormValidationUtils from './utils/form-validation-utils';
import * as LeadForm from './modules/signup-form';
import * as MobileNavMenus from './modules/mobile-nav-menus';
import * as SwatchbookUtils from './modules/swatchbook-utils';
import * as VideoHandler from './modules/videohandler';

import {
  dispatchSiteEvent,
  initSiteEvents,
} from './events/site-events';

import DesktopNavMenus from './modules/desktop-nav-menus';
import ExpandedPromo from './modules/expanded-promo';
import FilterMenus from './modules/filter-menus';
import GalleryModal from './modules/gallery-modal';
import GenesysMessengerUtils from './utils/genesys-messenger-utils';
import Glide from './vendors/glide.min';
import GridBuilder from './modules/grid-builder';
import GridSliders from './modules/grid-sliders';
import HeroSlider from './modules/hero-slider';
import InPageNav from './modules/in-page-nav';
import Lazyload from './modules/lazyload';
import MobileSearch from './modules/mobile-search';
import SlideInNav from './modules/slide-in-nav';
import StickySidebar from './modules/sticky-sidebar';
import SwatchCartIndicator from './modules/swatch-cart-indicator';
import TabRole from './modules/accessibility/tab-role';
import Tabnav from './modules/tabnav';
import Tabs from './modules/tabs';
import ThumbnailGallery from './modules/thumbnail-gallery';
import _ from 'underscore';
import { addTooltipsOnPageLoad } from './modules/tooltips';
import { getAutoplay } from './utils/glide-utils';
import videoModal from './modules/video-modal';

window.dispatchSiteEvent = dispatchSiteEvent;
window.useLocalStorage = true;
window.SwatchbookUtils = SwatchbookUtils;
window.VideoHandler = VideoHandler;
window.LeadForm = LeadForm;
window.FormValidationUtils = FormValidationUtils;

addTooltipsOnPageLoad();
ExpandedPromo();
FilterMenus();
GenesysMessengerUtils();
GridSliders();
initSiteEvents();
InPageNav();
Lazyload();
SwatchCartIndicator();
Tabnav();
HeroSlider.init();
TabRole();

const toggleHeaderMyAccountIconVisibility = () => {
  let ariaHidden = 'false';
  if (window.innerWidth < 992) {
    ariaHidden = 'true';
  }
  const myAccountNavLink = document.querySelector('.main-nav-list .my-account-nav-link');
  if (myAccountNavLink !== null) {
    myAccountNavLink.setAttribute('aria-hidden', ariaHidden);
  }
};
window.addEventListener('resize', toggleHeaderMyAccountIconVisibility);
toggleHeaderMyAccountIconVisibility();

// Nav Menu Interactivity
if (document.querySelector('.header')) {
  DesktopNavMenus.init({
    defaultSelected: '.nav--default-selected',
    header: '.header',
    mainMenuItem: '.header .nav-list-item',
    mainSubnav: '.nav-secondary',
    menuSelectors: '.header .nav--menu-item',
    menus: '.header .main-nav .get-started-list-item, .header .main-nav .products-list-item, .header .main-nav .dropdown-list-item',
    menuImageSelector: '.nav-image .img-wrap',
    navToggle: 'nav--active',
    subnavToggle: 'hidden',
  });
  MobileNavMenus.init({});
}

// Mobile Nav Interactivity
if (document.querySelector('.mobile-section')) {
  SlideInNav.init({
    activator: '#slide-nav',
    breakpoint: 992,
    notActive: '.mobile-nav',
    selector: '.mobile-section',
    toggle: '.slide-in',
  });
}

// Sticky Sidebar
if (document.querySelector('.sticky-sidebar')) {
  StickySidebar.init({
    stickyToggle: 'fixed',
    footerSelector: '.footer',
    headerSelector: '.header',
    selector: '.sticky-sidebar',
  });
}

// Search dropdown for mobile
if (document.querySelector('#header-search')) {
  MobileSearch.init({
    activator: '.search-icon',
    searchMenu: '#header-search',
    menuToggle: 'show-search',
  });
}

// Header Infoline Expand
if (document.querySelector('.header-infoline')) {
  const eventType = (navigator.userAgent.match(/(iPad|iPhone)/i) ? 'touchend' : 'click');
  // const infoline = document.querySelector('.header-infoline');
  const readMore = document.querySelector('.header-infoline .read-more');
  /* document.addEventListener(eventType, () => {
    readMore.previousElementSibling.classList.remove('hide');
    readMore.classList.remove('hide');
    readMore.nextElementSibling.classList.remove('show');
  }); */
  // infoline.addEventListener(eventType, event => event.stopPropagation());
  readMore.addEventListener(eventType, (event) => {
    event.currentTarget.previousElementSibling.classList.add('hide');
    event.currentTarget.classList.add('hide');
    event.currentTarget.nextElementSibling.classList.add('show');
  });
}

// Collapsed panels Microsite Productline page
if (document.querySelector('#productDropdown')) {
  $('#productDropdown').click(() => {
    $('#productDropdownList').toggle();
  });
}

if (document.querySelector('#features-expand')) {
  $('#features-expand').click(() => {
    $('.features-and-benefits .row-collapse').toggleClass('show');
    $('#features-plus-minus').toggleClass('minus');
  });
}

if (document.querySelector('#product-style-expand')) {
  $('.product-styles-content .row-collapse').toggleClass('show');
  $('#product-plus-minus').toggleClass('minus');
  $('#product-style-expand').click(() => {
    $('.product-styles-container.row-collapse').toggleClass('show');
    $('#product-plus-minus').toggleClass('minus');
  });
}

if (document.querySelector('#related-products-expand')) {
  $('#related-products-expand').click(() => {
    $('.related-products-container.row-collapse').toggleClass('show');
    $('#related-plus-minus').toggleClass('minus');
  });
}

// Glide (Simple Sliders)
if (document.querySelectorAll('.simple-slider').length > 0) {
  [].map.call(document.querySelectorAll('.simple-slider'), (slider) => {
    const autoplay = getAutoplay();
    // Is there more than 1 slide
    if (slider.querySelectorAll('.glide__slide').length > 1) {
      // Add glide
      const glide = new Glide(slider, {
        type: 'carousel',
        startAt: 0,
        perView: 1,
        focusAt: 'center',
        gap: 0,
        autoplay,
        hoverpause: true,
        breakpoints: {},
      });

      glide.mount();
    }
  });
}

// Tabs
if (document.querySelector('.tab')) {
  Tabs();
}

// Product Options Help Popup
if (document.querySelector('.help-popup') && !document.querySelector('.product-configuration')) {
  const helpPopupButtons = document.querySelectorAll('.help-popup-button');
  const helpPopups = document.querySelectorAll('.help-popup');

  document.addEventListener('click', () => {
    [].map.call(helpPopups, item => item.classList.add('hide'));
    VideoHandler.pauseAllVideos();
  });

  [].map.call(helpPopups, item => item.addEventListener('click', event => event.stopPropagation()));

  [].map.call(helpPopupButtons, item => item.addEventListener('click', (event) => {
    event.stopPropagation();
    if (event.currentTarget.nextElementSibling.classList.contains('hide')) {
      [].map.call(helpPopups, popup => popup.classList.add('hide'));
      event.currentTarget.nextElementSibling.classList.remove('hide');
    } else {
      [].map.call(helpPopups, popup => popup.classList.add('hide'));
    }
  }));

  [].map.call(document.querySelectorAll('.help-close-button'), (item) => {
    item.addEventListener('click', (event) => {
      event.stopPropagation();
      event.currentTarget.parentElement.classList.add('hide');
      VideoHandler.pauseAllVideos();
    });
  });
}

if (document.getElementById('hide-button')) {
  const hideButton = document.getElementById('hide-button');
  hideButton.addEventListener('click', () => {
    hideButton.parentElement.classList.add('hide');
  });
}

// Remove poster image and play video when play button is pressed
if (document.querySelector('.video-modal')) {
  const videoTemplate =
  `<div class="modal fade" id="modal-{{ newId }}" tabindex="-1" role="dialog" aria-labelledby="modal-label-{{ newId }}">
        <div class="container">
            <button type="button" class="btn-close" data-dismiss="modal"></button>
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-video">
                        {{ videoIframe }}
                    </div>
                </div>
            </div>
        </div>
    </div>`;
  GalleryModal.init({
    videoTemplate,
    galleryModalSelector: '.video-modal',
  });
} else if (document.querySelector('.video-embed')) {
  VideoHandler.init();

  // Stop help videos in product style pages
  if (document.querySelector('.help-close-button')) {
    [].map.call(document.querySelectorAll('.help-close-button'), item => item.addEventListener('click', () => VideoHandler.pauseAllVideos()));
  }
}

// Carousel Thumbnail Controls
if (document.querySelector('.thumbnail-container')) {
  ThumbnailGallery.setupGallery();
}

// Mailchimp Form
const template = _.template(`<div id="signup-form-container" class="signup-form-container hide">
    <div id="signup-form-wrapper" class="signup-form-wrapper">
      <div id="close-form" class="close-form"></div>
      <form id="signup-form" class="signup-form" name="signUpForm">
        <div class="form-heading">
          <h2>Let's stay in touch!</h2>
          <p>Sign up to receive the latest Bali&reg; deals, inspiration, and news in your email.<br><spam class="no-worries-unsubscribe">Don't worry&mdash;you can unsubscribe anytime.</span></p>
        </div>
        <div class="row">
          <div class="form-group col-sm-6">
            <label for="firstName">First Name</label>
            <input type="text" class="form-control" id="first-name" name="firstName" placeholder="First Name">
          </div>
          <div class="form-group col-sm-6">
            <label for="lastName">Last Name</label>
            <input type="text" class="form-control" id="last-name" name="lastName" placeholder="Last Name">
          </div>
        </div>
        <div class="form-group">
          <label for="emailAddress">Email</label>
          <input type="email" class="form-control" id="email-address" name="emailAddress" placeholder="Email Address" required>
          <span class="email-validation-error hide">Please enter a valid email address</span>
        </div>
        <button id="submit-form" type="submit" class="btn btn-default submit-form">Submit</button>
      </form>
      <div id="signup-response" class="signup-response hide">
        <div class="response-heading success-message hide">
          <h2>Thanks for signing up!</h2>
          <p>Get ready for the best in Bali deals, inspiration, and news. Check your inbox for a confirmation email.</p>
        </div>
        <div class="response-heading error-message hide">
          <h2>Oops! We're sorry.</h2>
          <p>Something went wrong&mdash;Please try again later.</p>
        </div>
      </div>
    </div>
  </div>`);

window.LeadFormTemplate = template;

if (document.querySelectorAll('.content-link')) {
  [].map.call(document.querySelectorAll('.content-link'), link => link.addEventListener('click', (event) => {
    event.preventDefault();
    const elem = document.getElementById(event.currentTarget.getAttribute('href').replace('#', ''));
    window.scrollTo(0, ((elem.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop)) - 156));
  }));
}

// Grid Overlay for dev
GridBuilder.init();

// Swatchbook Event Handlers
SwatchbookUtils.init();
SwatchbookUtils.localStorageSwatchEventHandlers();

// How to Order Modal on Costco Welcome Landing Page
if (document.querySelectorAll('.how-to-order-modal').length > 0) {
  [].map.call(document.querySelectorAll('.how-to-order-btn'), (btn) => {
    const modal = btn.parentElement.nextElementSibling;
    const closeBtn = modal.querySelector('.close-button');

    btn.addEventListener('click', () => {
      if (modal.classList.contains('modal-hidden')) {
        modal.classList.toggle('modal-hidden');
      }
    });

    closeBtn.addEventListener('click', () => {
      modal.classList.toggle('modal-hidden');
    });

    document.addEventListener('keydown', (e) => {
      if (!modal.classList.contains('modal-hidden') && e.key === 'Escape') {
        modal.classList.toggle('modal-hidden');
      }
    });
  });
}

// need to select the card and listen to the click on the btn. On click, should add .is-flipped to the card
if (document.querySelectorAll('.card-container--inner .flip-card').length > 0) {
  [].map.call(document.querySelectorAll('.flip-card'), (flipCard) => {
    const btn = flipCard.querySelector('.btn');
    const close = flipCard.querySelector('.close-button');
    if (btn) {
      btn.addEventListener('click', () => {
        flipCard.classList.toggle('is-flipped');
      });
    }
    if (close) {
      close.addEventListener('click', () => {
        // checks to make sure the card if actually flipped
        if (flipCard.classList.contains('is-flipped')) {
          // removes is-flipped
          flipCard.classList.toggle('is-flipped');
        }
      });
    }
  });
}

// Interactions on product Solutions Gallery - Motorization page 6/6/21 -jg
if (document.querySelectorAll('.product-solutions-gallery').length > 0) {
  [].map.call(document.querySelectorAll('.grid-item'), (gridItem) => {
    const modal = gridItem.nextElementSibling;
    // console.log(modal);
    const closeBtn = modal.querySelector('.close-button');
    const backBtn = modal.querySelector('.back-btn');

    gridItem.addEventListener('click', () => {
      if (modal.classList.contains('modal-hidden')) {
        modal.classList.toggle('modal-hidden');
      }
    });

    closeBtn.addEventListener('click', () => {
      modal.classList.toggle('modal-hidden');
    });

    backBtn.addEventListener('click', () => {
      modal.classList.toggle('modal-hidden');
    });

    document.addEventListener('keydown', (e) => {
      if (!modal.classList.contains('modal-hidden') && e.key === 'Escape') {
        modal.classList.toggle('modal-hidden');
      }
    });
  });
}

// Documents Drop Down Block video modal (install / measure pages. AT LEAST)
if (document.querySelector('.documents-dropdown')) {
  videoModal();
}
